
import {axiosInstance} from "../utilities/AxiosConfig";

export async function fetchItemSalesRateAndRestock() {
    const { data } = await axiosInstance.get("analytic/items");
    return data;
}

export async function fetchItemSlowAndNoSales({ months = 6, slowPercent = 20 } = {}) {
    const { data } = await axiosInstance.get("analytic/items/slow", {
        params: { months, slowPercent }
    });
    return data;
}